import { API_BASE_URL } from "../config";

function sleep(ms = 400) {
  return new Promise((r) => setTimeout(r, ms));
}

/**
 * API helper con supporto sia a cookie httpOnly che a Bearer token.
 * - credentials: "include" per inviare/ricevere cookie di sessione.
 * - Authorization solo se token è presente.
 */
export async function api(path, { method = "GET", body, token } = {}) {
  await sleep();

  const opts = {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include", // cookie-mode
  };

  if (body !== undefined) opts.body = JSON.stringify(body);
  if (token) opts.headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE_URL}${path}`, opts);

  const contentType = res.headers.get("content-type") || "";
  const isJSON = contentType.includes("application/json");
  const payload = isJSON ? await res.json() : await res.text();

  if (!res.ok)
    throw new Error(
      (isJSON ? payload?.message : payload) || `HTTP ${res.status}`
    );

  return payload;
}
